import * as types from './mutation-types'
import mensagens from '@/util/mensagens'
import { CATALOGO_PRODUTOS, montarValoresPadrao } from '../catalogo.mock'

// Task 2.3 — payload de salvamento: [{ produto, ativo, valor }]
const montarPayload = (valores) => Object.keys(valores).map(chave => ({
  produto: chave,
  ativo: valores[chave].ativo,
  valor: valores[chave].valor
}))

// Task 2.3 — carregar catálogo + valores.
// Mock agora: catálogo do arquivo mock e valores padrão (tudo inativo). A fonte-alvo é um endpoint do
// Manager que devolva o catálogo configurável + os valores já salvos do escritório (merge).
export const ActionCarregarProdutos = async ({ commit }, config = {}) => {
  commit(types.SET_CARREGANDO_DADOS, { status: true, mensagem: mensagens.carregandoDadosEdicao })
  try {
    const catalogo = config.catalogo || CATALOGO_PRODUTOS
    commit(types.SET_CATALOGO, catalogo)
    commit(types.SET_VALORES, config.valores || montarValoresPadrao(catalogo))
  } finally {
    commit(types.SET_CARREGANDO_DADOS, { status: false, mensagem: '' })
  }
}

export const ActionDefinirProdutoAtivo = ({ commit }, { chave, ativo }) => {
  commit(types.SET_PRODUTO_ATIVO, { chave, ativo })
}

export const ActionDefinirCampoValor = ({ commit }, payload) => {
  commit(types.SET_CAMPO_VALOR, payload)
}

// Task 2.3 — salvar: monta o payload por produto. A persistência central (banco do Manager) é etapa
// de backend (ver design.md); aqui apenas montamos e retornamos o payload no formato-alvo.
export const ActionSalvarProdutos = async ({ commit, state }, { idEmpresa } = {}) => {
  commit(types.SET_MANIPULANDO_DADOS, { status: true, mensagem: mensagens.salvandoDadosCadastro })
  try {
    const payload = {
      id_empresa: idEmpresa,
      produtos: montarPayload(state.valores)
    }
    // TODO(backend): POST para o endpoint de persistência central (ainda não existe — ver design.md).
    return payload
  } finally {
    commit(types.SET_MANIPULANDO_DADOS, { status: false, mensagem: '' })
  }
}

export const ActionResetarDadosRetornoCadastro = ({ commit }) => {
  commit(types.SET_DADOS_RETORNO_CADASTRO, { sucesso: false, mensagem: '', listaDeErros: {} })
}
